export type WindDirection = -1 | 1;
export type BalanceMotionState = {
  position: number; velocity: number; wind: WindDirection; elapsedMs: number;
  stabilisedMs: number; directionChanges: number;
  /** Rüzgâr gücü çarpanı; düşene kadar tekrar modunda her yeni turda artar. */
  windScale: number;
};

export const SAFE_CENTER_BAND = 0.34;
export const FALL_EDGE = 1;
export const BALANCE_MOTION_TUNING = {
  windForce: 0.18,
  stabilisedWindForce: 0.1,
  edgePull: 0.075,
  dampingPerFrame: 0.986,
} as const;

export function allowedWindChanges(questionCount: number): number {
  return questionCount < 9 ? 0 : questionCount <= 16 ? 1 : 2;
}

export function createBalanceMotionState(seed = 0): BalanceMotionState {
  return { position: 0, velocity: 0, wind: seed % 2 === 0 ? 1 : -1, elapsedMs: 0, stabilisedMs: 0, directionChanges: 0, windScale: 1 };
}

export function advanceBalanceMotion(state: BalanceMotionState, deltaMs: number): BalanceMotionState {
  const dt = Math.min(0.08, Math.max(0, deltaMs) / 1000);
  const stabilisedMs = Math.max(0, state.stabilisedMs - deltaMs);
  const windForce = (stabilisedMs > 0
    ? BALANCE_MOTION_TUNING.stabilisedWindForce
    : BALANCE_MOTION_TUNING.windForce) * (state.windScale ?? 1);
  const edgePull = Math.sign(state.position)
    * Math.pow(Math.abs(state.position), 1.5)
    * BALANCE_MOTION_TUNING.edgePull;
  const velocity = (state.velocity + (state.wind * windForce + edgePull) * dt)
    * Math.pow(BALANCE_MOTION_TUNING.dampingPerFrame, deltaMs / 16.67);
  return { ...state, position: state.position + velocity * dt, velocity, elapsedMs: state.elapsedMs + deltaMs, stabilisedMs };
}

export function applyCorrectBalance(state: BalanceMotionState): BalanceMotionState {
  return { ...state, position: state.position * 0.52, velocity: -state.position * 0.18, stabilisedMs: 900 };
}

export function maybeReverseWind(state: BalanceMotionState, questionCount: number, answered: number, seed: number): BalanceMotionState {
  const maximum = allowedWindChanges(questionCount);
  if (state.directionChanges >= maximum || Math.abs(state.position) > SAFE_CENTER_BAND) return state;
  const triggerA = Math.max(2, Math.floor(questionCount * 0.42));
  const triggerB = Math.max(triggerA + 2, Math.floor(questionCount * 0.72));
  const triggers = maximum === 1 ? [triggerA] : [triggerA, triggerB];
  const target = triggers[state.directionChanges] + (seed % 2);
  if (answered < Math.min(questionCount - 1, target)) return state;
  return { ...state, wind: state.wind === 1 ? -1 : 1, velocity: state.velocity * 0.45, directionChanges: state.directionChanges + 1 };
}
